(function () {

  'use strict';

  const FOCUSABLE_SELECTORS = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(', ');

  function pxTermsOfServiceDialog($filter, $rootScope, $timeout, toastr, TenantListService) {
    return {
      restrict: 'E',
      scope: {
      },
      templateUrl: 'app/components/subscription/termsOfServiceDialog/termsOfServiceDialog.template.html',
      link: function (scope, element, attributes) {

        scope.currentTenant = undefined;
        scope.currentUser = undefined;
        scope.termsOfServiceStatus = undefined;
        scope.loading = false;
        scope.accepting = false;
        scope.declining = false;

        scope.onAccepted = function () {
          acceptTermsOfService();
        };

        scope.onDeclined = function () {
          // scope.declining = true;
          // $rootScope.signOut();
          scope.termsOfServiceStatus = undefined;
        };

        scope.$watch(function () {
          return $rootScope.currentUser;
        }, function (currentUser) {
          if (currentUser) {
            scope.currentTenant = TenantListService.currentTenant;
            scope.currentUser = currentUser;
            getTermsOfServiceStatus();
          }
        });

        // Focus the first focusable element in the dialog when the Terms of Service dialog appears.
        scope.$watch('termsOfServiceStatus', function (termsOfServiceStatus) {
          if (termsOfServiceStatus && termsOfServiceStatus.acknowledgementRequired && termsOfServiceStatus.content) {
            $timeout(function () {
              const focusable = element[0].querySelector(FOCUSABLE_SELECTORS);
              if (focusable) {
                focusable.focus();
              }
            });
          }
        });

        scope.$on('$destroy', function () {
          document.removeEventListener('keydown', trapFocus, true);
        });

        (function () {
          document.addEventListener('keydown', trapFocus, true);
        })();

        function trapFocus(event) {

          // Only trap Tab key events.
          if (event.key !== 'Tab') {
            return;
          }

          // Only trap focus when the dialog is actually visible.
          const dialogElement = element[0].querySelector('.ui-dimmed-background-fullscreen');
          if (!dialogElement) {
            return;
          }

          // Get all focusable elements that are visible within the dialog.
          const focusable = Array.from(element[0].querySelectorAll(FOCUSABLE_SELECTORS))
            .filter(function (element) {
              return element.offsetParent !== null;
            });

          // If there are no focusable elements, prevent tabbing out of the dialog.
          if (!focusable.length) {
            event.preventDefault();
            return;
          }

          // Keep the focus cycling within the dialog.
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey) {
            if (document.activeElement === first || !element[0].contains(document.activeElement)) {
              event.preventDefault();
              last.focus();
            }
          } else {
            if (document.activeElement === last || !element[0].contains(document.activeElement)) {
              event.preventDefault();
              first.focus();
            }
          }

        }

        function getTermsOfServiceStatus() {
          if (scope.currentUser.isSystemManager()) {
            scope.loading = true;
            scope.currentTenant.getTermsOfServiceStatus()
              .then(function (termsOfServiceStatus) {
                scope.termsOfServiceStatus = termsOfServiceStatus;
              })
              .catch(function (response) {
                // Silently fail and don't show the dialog if the Terms of Service can't be retrieved. The users should
                // not be blocked from using the application if there's an issue with the service providing the Terms
                // of Service.
              })
              .finally(function () {
                scope.loading = false;
              });
          }
        }

        function acceptTermsOfService() {
          scope.accepting = true;
          scope.currentTenant.acceptTermsOfService(scope.termsOfServiceStatus.currentVersion)
            .then(function () {
              scope.termsOfServiceStatus = undefined;
            })
            .catch(function (response) {
              if (response.status <= 0) {
                // Network error or timeout.
                toastr.error($filter('translate')('TermsOfServiceAcknowledgementSaveError'));
              } else if (response.status === 403) {
                // The current user or tenant was deleted.
                $rootScope.signOut();
              } else if (response.status === 409) {
                // A more recent version of the Terms of Service was published.
                getTermsOfServiceStatus();
              } else {
                // Silently fail and hide the dialog.
                scope.termsOfServiceStatus = undefined;
              }
            })
            .finally(function () {
              scope.accepting = false;
            });
        }

      }
    };
  }

  pxTermsOfServiceDialog.$inject = ['$filter', '$rootScope', '$timeout', 'toastr', 'TenantListService'];

  angular
    .module('printix-admin')
    .directive('pxTermsOfServiceDialog', pxTermsOfServiceDialog);

})();
